import React, { useEffect } from 'react';
//asset
import ContactFondo from '../common/components/images/bg-contact.png';
// common component
import Layout from '../common/components/layout/Layout';
import Sports from '../common/components/modules/home/Sports';

import Contact from '../common/components/modules/home/Contact';
import { useDispatch } from 'react-redux';
import { fetchListSports } from '../modules/sport/actions/reducerListSport';

// home component

const Home = (): JSX.Element => {
    const dispatch = useDispatch();
    const setScrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        setScrollTop();
        dispatch(fetchListSports());
    }, []);

    return (
        <Layout navProps={{ title: 'Home | Supermatch', description: 'Supermatch' }}>
            <div className="snap-mandatory snap-y">
                <Sports />
                {/* <AttributeSports />
                <Steps /> */}
                <Contact background={ContactFondo} />
                {/* <StepsPlay /> */}
            </div>
        </Layout>
    );
};

export default Home;
